import React from 'react';
import WarningIcon from '@mui/icons-material/Warning';
import DashboardButton from './DashboardButton';

const ButtonUnComplete: React.FC = () => (
  <DashboardButton
    label="تکمیل اطلاعات"
    width={102}
    height={28}
    backgroundColor="transparent"
    textColor="#2563EB"
    startIcon={
      <WarningIcon
        style={{
          paddingLeft: '0px',
          color: '#F59E0B', // رنگ زرد/نارنجی
          width: '20px', // اندازه مشابه آیکون قبلی برای هماهنگی
          height: '20px',
          marginLeft: '4px',
          marginRight: '1px',
          borderRadius: '4px', // مشابه DraftIdentityIcon
        }}
      />
    }
  />
);

export default ButtonUnComplete;
